import { Injectable } from '@angular/core';
import { ScipTableFilterComponent } from './scip-table-filter.component';

@Injectable({
  providedIn: 'root'
})
export class ScipTableFilterService {
  private currentFilterMap: Map<string, ScipTableFilterComponent[]> = new Map();

  filterClicked(clickedFilter: ScipTableFilterComponent): void {
    Array.from(this.currentFilterMap.values()).forEach((filterForTable: ScipTableFilterComponent[]) => {
      filterForTable
        .filter((singleFilter: ScipTableFilterComponent) => singleFilter !== clickedFilter)
        .forEach((singleFilter: ScipTableFilterComponent) => {
          singleFilter.outsideClickDetected();
        });
    });
  }

  register(parentIdentifier: string, scipTableFilter: ScipTableFilterComponent): void {
    // The first filter which registers needs to setup the array
    if (!this.currentFilterMap.has(parentIdentifier)) {
      this.currentFilterMap.set(parentIdentifier, []);
    }
    // We want to be added to the list of the filters within that parent
    this.currentFilterMap.get(parentIdentifier).push(scipTableFilter);
  }

  unregister(parentIdentifier: string, scipTableFilter: ScipTableFilterComponent): void {
    // Lets remove us from the array
    const arrayWithoutCurrentFilter = this.currentFilterMap.get(parentIdentifier).filter((tableFilter) => {
      return tableFilter !== scipTableFilter;
    });

    if (arrayWithoutCurrentFilter.length) {
      this.currentFilterMap.set(parentIdentifier, arrayWithoutCurrentFilter);
    } else {
      // The last one also destroys the entry for the table itself
      this.currentFilterMap.delete(parentIdentifier);
    }
  }

  clearAllFilters(parentIdentifier: string): void {
    // We triggered the clear all button for the table with the given parentIdentifier
    if (this.currentFilterMap.get(parentIdentifier)) {
      // Iterate over all single filters and reset them all at once
      for (const singleFilter of this.currentFilterMap.get(parentIdentifier)) {
        singleFilter.resetFilter();
      }
    }
  }
}
